module.exports = {
    base: "/api",
    mock: "/mock"
};
